import { of } from 'rxjs'
import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { SegmentsElasticSearchService } from 'src/services/data/segments-elastic.service'
import { prepareFiltersPayload, prepareSegmentsPayload } from './segment-view-filters.utils'
import { TOP_LEVEL_FILTERS } from 'src/components/transportation-summary/transportation-summary-list/transportation-summary-list.filters'
import { loadSegmentViews, loadSegmentViewsFailure, loadSegmentViewsSuccess, loadSegmentFilters, loadSegmentFiltersFailure, loadSegmentFiltersSuccess } from './segment-view.actions'


@Injectable()
export class SegmentViewEffects {
  private actions$ = inject(Actions)
  private toaster = inject(ToasterService)
  private elastic = inject(SegmentsElasticSearchService)


  loadSegmentViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadSegmentViews),
    map(action => ({
      action,
      payload: prepareSegmentsPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) =>
      this.elastic.search({ ...payload, calculate: action.calculate }).pipe(
        map(r => loadSegmentViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          segmentViews: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch segments', loadSegmentViewsFailure
      )))))

  loadSegmentFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadSegmentFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadSegmentFiltersSuccess({ tableKey, result })),
      catchError(error => of(loadSegmentFiltersFailure({ error }))),
    ))))
}
